import { render, staticRenderFns } from "./DraggableItem.vue?vue&type=template&id=2d3be6bf&scoped=true&lang=html"
import script from "./DraggableItem.vue?vue&type=script&lang=js"
export * from "./DraggableItem.vue?vue&type=script&lang=js"
import style0 from "./DraggableItem.vue?vue&type=style&index=0&id=2d3be6bf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3be6bf",
  null
  
)

export default component.exports